import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import { FormHelperText, Grid, Typography } from "@mui/material";
import Carousel from "better-react-carousel";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTable from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import CustomUpload from "../../../components/CustomUpload";
import Select from "../../../components/Select/Select";
import { getDiagnosisList } from "../../../redux/reducers/clinicSlice";
import {
  createDiagnostics,
  createDiagnosticsByPetId,
  deleteDiagnosticsById,
  getPetDiagnostics,
  updateDiagnostics,
} from "../../../redux/reducers/petSlice";
import { AppColors } from "../../../util/AppColors";
import {
  diagnosticTypes,
  diagStatusList,
  doneAtList,
  priorityList,
} from "../../../util/dropList";
import { urlToFile } from "../../../util/function";
import FilesWithCloseButton from "../../Hospital/ClinicPetDetails/PatientWorkbook/FilesWithCloseButton";
import CreateUpdateReminder from "./CreateUpdateReminder";

const tableHeaders = [
  "testName",
  // "type",
  "category",
  "subCategory",
  "dueDate",
  "remarks",
  "statusDig",
  // "extraStatus",
  // "type",
  // "testName",
  // "dueDate",
  // "remarks",
  // "attachment",
  // "statusDig",
];

const nameExpan = {
  type: "Select Type",
  testName: "Test Name",
  variant: "Variant",
  dueDate: "Due Date",
  remarks: "Remarks",
  doneAt: "Done At",
  sampleType: "Sample Type",
  processingTime: "Processing Time",
  modality: "Modality",
  device: "Device",
  priority: "Priority",
  status: "Status",
  collectionTime: "Collection Time *",
};

const initialValues = {
  type: "Lab",
  testName: null,
  dueDate: new Date(),
  remarks: "",
  files: [],
  price: 0,
  tax: 0,
  sampleCollected: false,
  doneAt: doneAtList?.[0]?.value,
  collectionTime: new Date(),
  priority: "Routine",
  sampleCollected: false,
  status: "In Progress",
};

const initialErrors = { type: false, dueDate: false, remarks: false };
const initialHelpers = { type: "", dueDate: "", remarks: "" };
const plusBtn = { color: AppColors.appPrimary, width: 20, height: 20 };
const delBtn = { color: AppColors.red, width: 20, height: 20 };

const ReminderDiagnostics = ({ addVsble, setAddVsble, apntId }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { appointment } = location.state || {};
  const [modVisible, setModVisible] = useState(false);
  const [isEditModal, setEditModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [diagnosticsId, setDiagnosticsId] = useState(null);
  const [delModVsble, setDelModVsble] = useState(false);
  const [diagValues, setDiagValues] = useState(initialValues);
  const [diagnosticsHelpers, setDiagnosticsHelpers] = useState(initialHelpers);
  const [diagnosticsErrors, setDiagnosticsErrors] = useState(initialErrors);
  const [fileError, setFileError] = useState(false);
  const [attachModVisible, setAttachModVisible] = useState(false);
  const [attachments, setAttachments] = useState(null);
  const [page, setPage] = useState(1);
  const itemsPerLoad = 10;
  const appointmentId = appointment?.appoinment?.appointmentId;
  const petId = appointment?.appoinment?.petId;
  const defaultUrl = `?page=1&itemSize=${itemsPerLoad}&reminder=true`;
  const diagnostics = useSelector((state) => state?.pet?.diagnostics);
  const services = useSelector((state) => state?.clinic?.services);
  const apntDet = useSelector((state) => state?.pet?.complaintSummary?.data);

  useEffect(() => {
    dispatch(getPetDiagnostics({ petId, url: defaultUrl }));
    dispatch(getDiagnosisList());
  }, []);

  useEffect(() => {
    if (addVsble) setModVisible(addVsble);
  }, [addVsble]);

  const handleModClose = () => {
    setAddVsble(false);
    setModVisible(false);
    setDiagValues(initialValues);
    setDiagnosticsErrors(initialErrors);
    setDiagnosticsHelpers(initialHelpers);
    setEditModal(false);
    setDiagnosticsId(null);
    setSelectedItem(null);
  };

  const handleChangeValues = (name, value, addObj) => {
    const reqObj = { ...diagValues, [name]: value };
    if (name === "testName") {
      reqObj.price = addObj?.price;
      reqObj.tax = addObj?.tax;
      reqObj.doneAt = addObj.doneAt;
      reqObj.hsnSacCode = addObj?.hsnSacCode;
    }
    if (name === "variant") {
      reqObj.variantId = addObj?.variantId;
      reqObj.variantName = addObj?.variantName;
      const reqVar = getVariantsByServiceId(diagValues?.serviceId)?.find(
        (li) => li?.value === addObj?.variantId,
      );
      reqObj.price = reqVar?.servicePrice ?? 0;
    }
    if (addObj?.serviceId) {
      reqObj.serviceId = addObj?.serviceId;
      const reqVar = getVariantsByServiceId(addObj?.serviceId);
      if (reqVar?.[0]?.variantId) {
        reqObj.variantId = reqVar?.[0]?.variantId;
        reqObj.variantName = reqVar?.[0]?.variantName;
        reqObj.variant = reqVar?.[0]?.variantId;
        reqObj.price = reqVar?.[0]?.servicePrice ?? 0;
      }
    }
    if (name === "sampleCollected" && value) {
      reqObj.dueDate = new Date();
      reqObj.collectionTime = new Date();
    }
    setDiagValues(reqObj);
    setDiagnosticsErrors({
      ...diagnosticsErrors,
      [name]:
        value?.length > 0 || typeof value === "number"
          ? false
          : name === "dueDate"
            ? false
            : name === "collectionTime"
              ? false
              : true,
    });
    setDiagnosticsHelpers({
      ...diagnosticsHelpers,
      [name]:
        value?.length > 0 || typeof value === "number"
          ? ""
          : name === "dueDate"
            ? ""
            : name === "collectionTime"
              ? ""
              : `${name === "type" ? "Type" : nameExpan?.[name]} is required`,
    });
  };

  const onUploadFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists = diagValues?.files?.length > 0 ? [...diagValues?.files] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [
            ...fileLists,
            {
              file: file,
              previewUrl: reader.result,
            },
          ];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });

    Promise.all(readFiles)
      .then(() => setDiagValues({ ...diagValues, files: fileLists }))
      .catch((error) => console.error("Error reading files: ", error));
  };

  const handleImageRemove = (ind) => {
    const reqFiles = diagValues?.files?.filter((fl, i) => i !== ind);
    setDiagValues({ ...diagValues, files: reqFiles });
  };

  const getDiagnostics = () => {
    return services?.data
      ?.filter(
        (dl) =>
          dl?.active === "Y" &&
          dl?.category?.toLowerCase() === diagValues?.type?.toLowerCase(),
      )
      ?.map((dl) => ({
        ...dl,
        name: dl?.serviceName,
        value: dl?.serviceName,
        servicePrice: dl?.serviceVariants?.[0]?.serviceCharge,
      }));
  };

  const getServiceDetById = (servId) => {
    return services?.data?.find((ser) => ser?.serviceId === servId);
  };

  const handleEditModal = (diagnostics) => {
    setDiagnosticsId(diagnostics?.diagonosticId);
    setSelectedItem(diagnostics);
    const reqDia = getServiceDetById(diagnostics?.serviceId);
    const [hour, min] =
      diagnostics?.collectionTime?.length > 0
        ? diagnostics?.collectionTime?.split(":")
        : ["00:00"];

    const reqObj = {
      type: diagnostics?.type,
      testName: diagnostics?.testName,
      remarks: diagnostics?.remark,
      dueDate: diagnostics?.dueDate,
      price: reqDia?.servicePrice ?? reqDia?.sellPrice ?? 0,
      tax: reqDia?.tax ?? 0,
      serviceId: reqDia?.serviceId,
      files: diagnostics?.file?.map((fle) => ({ previewUrl: fle })),
      doneAt: diagnostics?.doneAt,
      sampleCollected: diagnostics?.sampleCollected === "Y",
      priority: diagnostics?.priority,
      status: diagnostics?.status,
      collectionTime: new Date(
        new Date().setHours(hour ? hour : 0, min ? min : 0),
      ),
      hsnSacCode: reqDia?.hsnSacCode ?? null,
    };
    if (diagnostics?.variantId) {
      reqObj.variantId = diagnostics?.variantId;
      const vnts = getVariantsByServiceId(
        reqDia?.serviceId ?? diagnostics?.serviceId,
      );
      if (vnts?.length > 0) {
        const reqVar = vnts?.find(
          (vt) => vt?.variantId === diagnostics?.variantId,
        );
        if (reqVar) {
          reqObj.variantId = reqVar?.variantId;
          reqObj.variantName = reqVar?.variantName;
          reqObj.variant = reqVar?.variantId;
        }
      }
    }
    setDiagValues(reqObj);
    setModVisible(true);
    setEditModal(true);
  };

  const handleAttachmentModal = (diagnostics) => {
    setDiagnosticsId(diagnostics?.diagonosticId);
    setSelectedItem(diagnostics);
    const reqDia = getServiceDetById(diagnostics?.serviceId);
    const [hour, min] =
      diagnostics?.collectionTime?.length > 0
        ? diagnostics?.collectionTime?.split(":")
        : ["00:00"];

    const reqObj = {
      type: diagnostics?.type,
      testName: diagnostics?.testName,
      remarks: diagnostics?.remark,
      dueDate: diagnostics?.dueDate,
      price: reqDia?.servicePrice ?? reqDia?.sellPrice ?? 0,
      tax: reqDia?.tax ?? 0,
      serviceId: reqDia?.serviceId,
      files: diagnostics?.file?.map((fle) => ({ previewUrl: fle })),
      doneAt: diagnostics?.doneAt,
      sampleCollected: diagnostics?.sampleCollected === "Y",
      priority: diagnostics?.priority,
      status: diagnostics?.status,
      collectionTime: new Date(
        new Date().setHours(hour ? hour : 0, min ? min : 0),
      ),
    };
    if (diagnostics?.variantId) {
      reqObj.variantId = diagnostics?.variantId;
      const vnts = getVariantsByServiceId(
        reqDia?.serviceId ?? diagnostics?.serviceId,
      );
      if (vnts?.length > 0) {
        const reqVar = vnts?.find(
          (vt) => vt?.variantId === diagnostics?.variantId,
        );
        if (reqVar) {
          reqObj.variantId = reqVar?.variantId;
          reqObj.variantName = reqVar?.variantName;
          reqObj.variant = reqVar?.variantId;
        }
      }
    }
    setDiagValues(reqObj);
    setModVisible(true);
    setEditModal(true);
  };

  const handleSave = async (status) => {
    //handle validation
    const err = {};
    const hlp = {};
    if (!diagValues?.type) {
      err.type = true;
      hlp.type = "Type is required";
    }
    if (!diagValues?.dueDate) {
      err.dueDate = true;
      hlp.dueDate = "Due Date is required";
    }
    if (Object.keys(err).length > 0) {
      setDiagnosticsErrors({ ...diagnosticsErrors, ...err });
      setDiagnosticsHelpers({ ...diagnosticsHelpers, ...hlp });
      return;
    }
    const form = new FormData();
    if (
      apntId &&
      // apntDet?.appointment?.appointmentDate ===
      //   moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD") &&
      diagValues?.sampleCollected
    ) {
      form.append("appId", apntId);
    }
    form.append("type", diagValues?.type);
    form.append("testName", diagValues?.testName);
    form.append("doneAt", diagValues?.doneAt);
    form.append("sampleCollected", diagValues?.sampleCollected);
    form.append("priority", diagValues?.priority);
    form.append("price", Number(diagValues?.price ?? 0));
    form.append("tax", Number(diagValues?.tax ?? 0));
    form.append(
      "dueDate",
      moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD"),
    );
    form.append("remark", diagValues?.remarks);
    form.append("hsnSacCode", Number(diagValues?.hsnSacCode ?? null));
    if (diagValues?.serviceId) {
      form.append("serviceId", diagValues?.serviceId);
    }
    if (diagValues?.variant ?? diagValues?.variantId) {
      form.append("variantId", diagValues?.variant ?? diagValues?.variantId);
    }
    if (diagValues?.variantName) {
      form.append("variantName", diagValues?.variantName);
    }
    if (
      apntId &&
      diagValues?.sampleCollected &&
      (selectedItem
        ? selectedItem?.dueDate !==
            moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD") &&
          apntDet?.appointment?.appointmentDate ===
            moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD")
        : apntDet?.appointment?.appointmentDate ===
          moment(new Date(diagValues?.dueDate)).format("YYYY-MM-DD"))
    ) {
      form.append("addToBilling", true);
    }
    if (diagValues?.sampleCollected) {
      if (diagValues?.files?.length > 0) {
        const filePromises = diagValues?.files?.map(async (fle) => {
          if (fle?.file) {
            return fle?.file; // Local File
          } else {
            return await urlToFile(fle?.previewUrl); // Remote File
          }
        });
        const finalFiles = await Promise.all(filePromises);
        finalFiles?.forEach((file) => {
          form.append("file", file);
        });
        // diagValues?.files?.forEach((fle) => {
        //   form.append("file", fle?.file ?? fle?.previewUrl);
        // });
      }
      if (
        diagValues?.files?.length === 0 ||
        (!diagValues?.files && selectedItem?.file?.length > 0)
      ) {
        form.append("fileDelete", true);
      }
      form.append(
        "collectionTime",
        moment(new Date(diagValues?.collectionTime)).format("HH:mm"),
      );
    }
    let isFile = false;
    if (
      diagnostics?.data?.find((dia) => dia?.diagonosticId === diagnosticsId)
        ?.status === "Completed"
    ) {
      isFile = true;
    }
    if (!diagValues?.sampleCollected) {
      form.append("status", "Scheduled");
    }
    if (diagValues?.sampleCollected) {
      if (diagValues?.files?.length > 0) {
        form.delete("status");
        form.append("status", "Pending Review");
      } else {
        form.delete("status");
        form.append("status", "In progress");
      }
    }
    if (selectedItem?.status?.toLowerCase() === "pending review") {
      form.delete("status");
      form.append("status", "Completed");
    }
    if (isFile) {
      form.delete("status");
      form.append("status", "Completed");
    }
    if (!isEditModal) {
      dispatch(
        appointmentId && diagValues?.sampleCollected
          ? createDiagnostics({ appointmentId, form, formData: true })
          : createDiagnosticsByPetId({ petId, form, formData: true }),
      ).then((res) => {
        if (res?.payload?.status === 200) {
          dispatch(getPetDiagnostics({ petId, url: defaultUrl }));
          setPage(1);
          handleModClose();
          setFileError(false);
        }
      });
    } else {
      const metaUpdate = { diagnosticsId, form };
      dispatch(updateDiagnostics(metaUpdate)).then((res) => {
        if (res?.payload?.status === 200) {
          dispatch(getPetDiagnostics({ petId, url: defaultUrl }));
          setPage(1);
          handleModClose();
          setFileError(false);
        }
      });
    }
  };

  const handleChangePage = (e, selectedPage) => {
    dispatch(
      getPetDiagnostics({
        petId,
        url: `?page=${selectedPage}&itemSize=${itemsPerLoad}&reminder=true`,
      }),
    );
    setPage(selectedPage);
  };

  const handleAttachments = (diag) => {
    setAttachments(diag?.file);
    setAttachModVisible(true);
  };

  const handleClosePrevMod = () => {
    setAttachModVisible(false);
    setAttachments(null);
  };

  const getVariantsByServiceId = (servId = null) => {
    if (!servId) return [];
    const servDet = getServiceDetById(servId);
    if (servDet) {
      return servDet?.serviceVariants?.map((vnt) => ({
        ...vnt,
        name: vnt?.variantName,
        value: vnt?.variantId,
      }));
    }

    return [];
  };

  const handleDelete = (diag) => {
    setDiagnosticsId(diag?.diagonosticId);
    setDelModVsble(true);
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setDiagnosticsId(null);
  };

  const onConfirmDelete = () => {
    if (!diagnosticsId) return;
    dispatch(deleteDiagnosticsById(diagnosticsId)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        dispatch(getPetDiagnostics({ petId, url: defaultUrl }));
      }
    });
  };

  const getRequiredDiagnostics = () => {
    return diagnostics?.data?.filter(
      (li) => !li?.appoinment?.appointmentId,
      //   {
      //   const dateMatch = apntId
      //     ? li?.dueDate !== apntDet?.appointment?.appointmentDate
      //     : true;
      //   return dateMatch;
      // }
    );
  };

  const onCloseMod = (typ) => {
    if (typ === "apiSuccess") {
      dispatch(getPetDiagnostics({ petId, url: defaultUrl }));
      setPage(1);
    }
    handleModClose();
  };

  return (
    <>
      <Grid container>
        <div className="pb100 w100Per">
          <CustomTable
            grey
            columns={tableHeaders}
            datas={getRequiredDiagnostics()?.map((diag, i) => {
              const reqServ = services?.data?.find(
                (ser) => ser?.serviceId === diag?.serviceId,
              );
              return {
                ...diag,
                category: reqServ?.category ?? "",
                subCategory: reqServ?.subCategory ?? "",
                remarks: diag?.remark,
                type: diag?.type,
                // <strong>{diag?.type}</strong>,
                dueDate: moment(diag?.dueDate).format("DD MMM YYYY"),
                // attachment: (
                //   <div className="flex-row-ali-cen">
                //     <img
                //       src={require("../../../assets/images/png/PlusIcon.png")}
                //       alt=""
                //       className="img-wh20 cursor"
                //       onClick={() => handleAttachmentModal(diag)}
                //     />

                //     <div
                //       className="txt-regular fs12 blue-color ml10 cursor"
                //       onClick={() => {
                //         if (diag?.file?.length > 0) handleAttachments(diag);
                //       }}
                //     >
                //       {diag?.file?.length > 0
                //         ? `${diag?.file?.length} Files`
                //         : "Nil"}
                //     </div>
                //   </div>
                // ),
                statusDig: (
                  <div className="flex-row">
                    <div
                      // className={
                      //   diag?.status === "Completed" ||
                      //   diag?.status === "File"
                      //     ? "completed"
                      //     : diag?.status === "Pending"
                      //     ? "pending"
                      //     : "overdue"
                      // }
                      className={
                        new Date(diag?.dueDate) >
                        new Date(new Date().setHours(0, 0, 0, 0))
                          ? "pending"
                          : "overdue"
                      }
                    >
                      {new Date(diag?.dueDate) >
                      new Date(new Date().setHours(0, 0, 0, 0))
                        ? "Pending"
                        : "Overdue"}
                    </div>
                    <div className="flex1-end">
                      <div
                        className="cursor"
                        onClick={() => handleEditModal(diag)}
                      >
                        <div className="flex-center">
                          <EditIcon sx={plusBtn} />
                        </div>
                        <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                          Edit
                        </Typography>
                      </div>

                      <div
                        className="cursor ml20"
                        onClick={() => handleDelete(diag)}
                      >
                        <div className="flex-center">
                          <DeleteOutlineIcon sx={delBtn} />
                        </div>
                        <Typography className="red3 fs8 txt-semi-bold text-align-center">
                          Delete
                        </Typography>
                      </div>
                    </div>
                  </div>
                ),
              };
            })}
            // onClickEditBtn={handleEdit}
            page={page}
            rowsPerPage={itemsPerLoad}
            totalRecords={diagnostics?.totalRecords}
            handleChangePage={handleChangePage}
          />
        </div>
      </Grid>
      {modVisible ? (
        <CreateUpdateReminder
          modVsble={modVisible}
          onCloseMod={onCloseMod}
          selectedItem={selectedItem}
          selecetdtype="Diagnostics"
          addToAppointment={false}
        />
      ) : null}

      <CustomModal
        open={attachModVisible}
        onClose={handleClosePrevMod}
        header="Preview"
        modal
        modalWidth={50}
      >
        <Carousel cols={1} rows={1} gap={10} loop showDots>
          {attachments?.map((fle, i) => {
            // const reqFle = fle?.replace("https://", "http://");
            const reqFle = fle;
            const fileType = reqFle?.split(".").pop();
            const isImg = ["png", "jpg", "jpeg"].includes(fileType);

            return (
              <Carousel.Item>
                <div className="flex-center">
                  {isImg ? (
                    <img src={reqFle} alt="" className="chat-file-prev" />
                  ) : (
                    <iframe
                      className="chat-file-prev"
                      frameborder="0"
                      src={`https://docs.google.com/gview?url=${reqFle}&embedded=true`}
                    />
                  )}
                </div>
              </Carousel.Item>
            );
          })}
        </Carousel>
      </CustomModal>

      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the diagnostics?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={onConfirmDelete}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={onCloseDelMod} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default ReminderDiagnostics;
